import {
  ARTICLES_GET_ARTICLES_REQUEST,
  ARTICLES_GET_ARTICLES_SUCCESS,
  ARTICLES_GET_ARTICLES_FAIL,
  ARTICLES_GET_CATEGORIES_REQUEST,
  ARTICLES_GET_CATEGORIES_SUCCESS,
  ARTICLES_GET_CATEGORIES_FAIL,
  ARTICLES_GET_AUTHORS_REQUEST,
  ARTICLES_GET_AUTHORS_SUCCESS,
  ARTICLES_GET_AUTHORS_FAIL,
  ARTICLES_GET_ARTICLE_REQUEST,
  ARTICLES_GET_ARTICLE_SUCCESS,
  ARTICLES_GET_ARTICLE_FAIL,
  ARTICLES_EDIT_ARTICLE_REQUEST,
  ARTICLES_EDIT_ARTICLE_SUCCESS,
  ARTICLES_EDIT_ARTICLE_FAIL,
  ARTICLES_CREATE_ARTICLE_REQUEST,
  ARTICLES_CREATE_ARTICLE_SUCCESS,
  ARTICLES_CREATE_ARTICLE_FAIL,
  ARTICLES_REMOVE_ARTICLE_REQUEST,
  ARTICLES_REMOVE_ARTICLE_SUCCESS,
  ARTICLES_REMOVE_ARTICLE_FAIL,
} from "../actions/articles";

const initialState = {
  getArticlesRequest: false,
  getArticleRequest: false,
  getAuthorsRequest: false,
  removeArticleRequest: false,
  getCategoriesRequest: false,
  editArticleRequest: false,
  categories: [],
  errorMsg: "",
  successMsg: "",
  successBackMsg: "",
  errors: {},
  articles: [],
  authors: [],
  articlesPagination: {},
  selectedArticles: [],
  selectedArticle: null
};

const articles = (state = initialState, action) => {
  switch (action.type) {
    case ARTICLES_GET_ARTICLES_REQUEST:
      return {
        ...state,
        getArticlesRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {}
      };
    case ARTICLES_GET_ARTICLES_SUCCESS:
      return {
        ...state,
        getArticlesRequest: false,
          errorMsg: "",
          successMsg: "",
          errors: {},
          articles: action.data.data,
          articlesPagination: {
            currentPage: action.data.current_page,
            lastPage: action.data.last_page,
          }
      };
    case ARTICLES_GET_ARTICLES_FAIL:
      return {
        ...state,
        getArticlesRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors
      };
    case ARTICLES_GET_CATEGORIES_REQUEST:
      return {
        ...state,
        getCategoriesRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {}
      };
    case ARTICLES_GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        getCategoriesRequest: false,
          errorMsg: "",
          successMsg: "",
          errors: {},
          categories: action.data,
      };
    case ARTICLES_GET_CATEGORIES_FAIL:
      return {
        ...state,
        getCategoriesRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors
      };
    case ARTICLES_GET_AUTHORS_REQUEST:
      return {
        ...state,
        getAuthorsRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {}
      };
    case ARTICLES_GET_AUTHORS_SUCCESS:
      return {
        ...state,
        getAuthorsRequest: false,
          errorMsg: "",
          successMsg: "",
          errors: {},
          authors: action.data.data,
      };
    case ARTICLES_GET_AUTHORS_FAIL:
      return {
        ...state,
        getAuthorsRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors
      };
    case ARTICLES_GET_ARTICLE_REQUEST:
      return {
        ...state,
        getArticleRequest: true,
          successMsg: "",
          errorMsg: "",
          errors: {},
          selectedArticle: {}
      };
    case ARTICLES_GET_ARTICLE_SUCCESS:
      return {
        ...state,
        getArticleRequest: false,
          successMsg: "",
          errorMsg: "",
          errors: {},
          selectedArticle: action.data
      };
    case ARTICLES_GET_ARTICLE_FAIL:
      return {
        ...state,
        getArticleRequest: false,
          successMsg: "",
          errorMsg: action.msg,
          errors: action.errors,
          selectedArticle: {}
      };
    case ARTICLES_EDIT_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          successBackMsg: "",
          errorMsg: "",
          errors: {},
      };
    case ARTICLES_EDIT_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: action.msg,
          errorMsg: "",
          errors: {},
      };
    case ARTICLES_EDIT_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: "",
          errorMsg: action.msg,
          errors: action.errors,
      };
    case ARTICLES_CREATE_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          successBackMsg: "",
          errorMsg: "",
          errors: {},
      };
    case ARTICLES_CREATE_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: action.msg,
          errorMsg: "",
          errors: {},
      };
    case ARTICLES_CREATE_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: "",
          errorMsg: action.msg,
          errors: action.errors,
      };
    case ARTICLES_REMOVE_ARTICLE_REQUEST:
      return {
        ...state,
        removeUserRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {},
          selectedArticle: {}
      };
    case ARTICLES_REMOVE_ARTICLE_SUCCESS:
      return {
        ...state,
        removeUserRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          selectedArticle: {}
      };
    case ARTICLES_REMOVE_ARTICLE_FAIL:
      return {
        ...state,
        removeUserRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors,
          selectedArticle: {}
      };

    default:
      return state;
  }
};

export default articles;